import type { StaffCapabilityCheck } from '~/modules/staff/application/staff-permissions'

export function canReadEntrepreneurReport(can: StaffCapabilityCheck) {
  return can('entrepreneur-dashboard', 'EntrepreneurReport', 'read')
}

export function canAssignEntrepreneurEvents(can: StaffCapabilityCheck) {
  return can('entrepreneur-dashboard', 'EntrepreneurEventAssignment', 'assign')
}

export function staffLandingPath(can: StaffCapabilityCheck) {
  return canReadEntrepreneurReport(can) && !canAssignEntrepreneurEvents(can) ? '/staff/entrepreneur' : '/staff'
}
